<template>
  <div class="header">
    <div class="main">
      <h1 class="inline" @click="goPath2('/home')">
        <img src="../../assets/logo.png" alt="" />
      </h1>

      <nav class="fright">
        <div>
          <div
            v-for="(item, index) in navList"
            :key="index"
            class="fleft nav"
            :class="{ active: activeIndex === index }"
            @click.stop="handleNavClick(item, index)"
            @mouseover="handleNavHover(item, index)"
          >
            <h2>{{ item.name }}</h2>
            <transition name="bounce">
              <div
                v-if="
                  showSubNav &&
                  hoveredIndex === index &&
                  item.children &&
                  item.children.length &&
                  !item.isProduct
                "
                class="subNav"
                @mouseleave="showSubNav = false"
              >
                <div
                  v-for="(child, childIndex) in item.children"
                  :key="childIndex"
                  :class="{ active: activeSubIndex === childIndex }"
                  @click.stop="goSubPage(child)"
                  @mouseenter="activeSubIndex = childIndex"
                >
                  {{ child.name }}
                  <span></span>
                </div>
              </div>
            </transition>
          </div>
          <div class="fleft nav">
            <el-dropdown @command="switchLang">
              <span class="el-dropdown-link">
                {{ currentLang === "zh" ? "中文" : "English" }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh">中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </nav>
    </div>

    <!-- 产品弹窗 -->
    <el-dialog
      class="isProduct_wrap"
      :modal="false"
      custom-class="custom-dialog"
      :visible.sync="dialogVisible"
      width="1200px"
      append-to-body
      :show-close="false"
    >
      <el-container
        class="isProduct"
        :class="[
          currentProduct.children && currentProduct.children.length
            ? 'shadow'
            : 'onlyBar',
          { 'lang-en': currentLang === 'en' },
        ]"
      >
        <el-aside width="160px" style="background-color: #ededed">
          <ul>
            <li
              v-for="(cat, idx) in productCategories"
              :key="idx"
              :class="{ bg: activeCategoryIndex === idx }"
              @click="selectProductCategory(cat, idx)"
            >
              {{ cat.name }}
              <span
                v-if="cat.childrens && cat.childrens.length"
                class="el-icon-arrow-right"
              ></span>
            </li>
          </ul>
        </el-aside>
        <el-main
          v-if="currentProduct.childrens && currentProduct.childrens.length"
          style="background-color: #fff"
        >
          <h3 class="typeName" @click="goProductDetail(currentProduct.id, -1)">
            {{ currentProduct.name }}
          </h3>
          <hr />
          <div
            v-for="(group, gIdx) in currentProduct.childrens"
            :key="gIdx"
            class="threeType"
          >
            <h4
              class="typeLastName"
              :class="{ active: activeTypeIndex === gIdx }"
              @click="goProductDetail(group.id, gIdx)"
            >
              {{ group.name }}
            </h4>
            <div v-for="(sub, sIdx) in group.childrens" :key="sIdx">
              <p @click="goProductDetail(sub.id, sIdx)">
                {{ sub.name }} <span class="el-icon-arrow-right"></span>
              </p>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-dialog>

    <!-- 移动端抽屉 -->
    <el-dropdown class="rightMenu1" @command="switchLang">
      <span class="el-dropdown-link">
        {{ currentLang === "zh" ? "中文" : "English" }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh">中文</el-dropdown-item>
        <el-dropdown-item command="en">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="rightMenu" @click="drawer = true">
      <span><i></i></span>
    </div>

    <el-drawer size="200px" :append-to-body="true" :visible.sync="drawer" direction="rtl">
      <div class="menu">
        <div v-for="(item, idx) in navList" :key="idx" @click="goPath(item)">
          {{ item.name }}
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getProductTree,
  applyDomainList,
  getDictList,
  getProductList,
  getProductDetail,
} from "../../api/index";

export default {
  data() {
    return {
      activeIndex: 0, // 当前高亮的一级导航索引
      activeSubIndex: -1, // 子菜单 hover 项索引
      hoveredIndex: -1, // 当前 hover 的一级导航索引
      showSubNav: false, // 是否显示二级菜单浮层
      drawer: false, // 移动端抽屉状态
      dialogVisible: false, // 产品弹窗显示状态
      productCategories: [], // 产品侧边栏分类列表
      currentProduct: { childrens: [] }, // 当前选中的产品分类详情
      activeCategoryIndex: 0, // 侧边栏选中索引
      activeTypeIndex: -1, // 三级分类选中索引
      productChildren: [], // 产品子菜单数据
      applyChildren: [], // 应用领域子菜单
      zlykkxChildren: [], // 质量可靠性子菜单
    };
  },

  computed: {
    // 当前语言（直接从 i18n 获取，保证响应式）
    currentLang: function () {
      return (
        (this.$i18nState && this.$i18nState.locale) ||
        (this.$i18n && this.$i18n.locale) ||
        "zh"
      );
    },

    // 根据语言动态生成导航列表
    navList: function () {
      if (this.currentLang === "zh") {
        return this.getZhNavList();
      } else {
        return this.getEnNavList();
      }
    },
  },

  watch: {
    // 监听路由变化（关闭抽屉，高亮当前导航）
    $route: {
      handler: function () {
        this.drawer = false;
        this.updateActiveNavByRoute();
      },
      immediate: true,
    },
    // 监听语言切换，重新加载动态菜单数据
    currentLang: function () {
      this.loadMenuData();
    },
  },

  mounted: function () {
    this.loadMenuData();
  },

  methods: {
    // ----- 导航数据定义 -----
    getZhNavList: function () {
      return [
        { name: this.$t("home"), path: "/home", isProduct: false },
        {
          name: this.$t("product"),
          path: "/product/index",
          children: this.productChildren,
          isProduct: true,
        },
        {
          name: this.$t("apply"),
          path: "/apply",
          children: this.applyChildren,
          isProduct: false,
        },
        {
          name: this.$t("zlykkx"),
          path: "/zlykkx/zlgl",
          children: this.zlykkxChildren,
          isProduct: false,
        },
        {
          name: this.$t("support"),
          path: "/fwzc/onlineClass",
          children: [
            { name: this.$t("onlineClass"), path: "/fwzc/onlineClass" },
            { name: this.$t("tecArticles"), path: "/fwzc/tecArticles" },
          ],
          isProduct: false,
        },
        {
          name: this.$t("aboutUs"),
          path: "/about",
          children: [
            { name: this.$t("introduce"), path: "/about" },
            { name: this.$t("news"), path: "/news" },
            { name: this.$t("contact"), path: "/introduce" },
            { name: this.$t("xsydls"), path: "/fwzc/xsydls" },
          ],
          isProduct: false,
        },
        {
          name: this.$t("joinUs"),
          path: "/joinUs",
          isProduct: false,
        },
      ];
    },

    getEnNavList: function () {
      return [
        { name: this.$t("home"), path: "/home", isProduct: false },
        {
          name: this.$t("product"),
          path: "/product/index",
          children: this.productChildren,
          isProduct: true,
        },
        {
          name: this.$t("apply"),
          path: "/apply",
          children: this.applyChildren,
          isProduct: false,
        },
        {
          name: this.$t("zlykkx"),
          path: "/zlykkx/zlgl",
          children: this.zlykkxChildren,
          isProduct: false,
        },
        {
          name: this.$t("aboutUs"),
          path: "/about",
          isProduct: false,
        },
      ];
    },

    // ----- 数据加载 -----
    loadMenuData: function () {
      var langCode = this.currentLang === "zh" ? "zh-CN" : "en-US";
      var params = { languageCode: langCode };
      var self = this;

      Promise.all([
        getProductTree(params),
        applyDomainList(params),
        getDictList("cms_quality_reliability"),
      ])
        .then(function (results) {
          var productRes = results[0];
          var applyRes = results[1];
          var dictRes = results[2];

          // 产品数据
          self.productChildren = productRes.data || [];

          // 应用领域数据（添加 path）
          self.applyChildren = (applyRes.rows || []).map(function (item) {
            return Object.assign({}, item, { path: "/apply" });
          });

          // 质量可靠性数据（中英文名称 + path）
          self.zlykkxChildren = (dictRes.data || []).map(function (item) {
            return {
              dictValue: item.dictValue,
              dictLabel: item.dictLabel,
              dictLabelEn: item.dictLabelEn,
              path: "/zlykkx/zlgl?id=" + item.dictValue,
              name: self.currentLang === "zh" ? item.dictLabel : item.dictLabelEn,
            };
          });

          // 更新产品弹窗侧边栏数据（取自产品分类）
          if (self.productChildren.length) {
            self.productCategories = self.productChildren;
            self.currentProduct = self.productChildren[0] || { childrens: [] };
          }
        })
        .catch(function (error) {
          console.error("加载菜单数据失败：", error);
        });
    },

    // ----- 语言切换（正确修改 i18n 和路由）-----
    // switchLang: function (lang) {
    //   if (lang === this.currentLang) return;

    //   // 更新 i18n 实例
    //   if (this.$i18nState) {
    //     this.$i18nState.locale = lang;
    //   } else if (this.$i18n) {
    //     this.$i18n.locale = lang;
    //   }
    //   // 更新路由中的语言后缀
    //   var currentPath = this.$route.path;
    //   if (currentPath == "/product/index/zh") {
    //     this.$router.replace({
    //       path: "/product/index/en",
    //       query: { id: 39 },
    //     });
    //     return;
    //   } else if (currentPath == "/product/index/en") {
    //     this.$router.replace({
    //       path: "/product/index/zh",
    //       query: { id: 12 },
    //     });
    //     return;
    //   } else if (currentPath == "/product/productDetail/" + (this.currentLang == "zh" ? "en" : "zh")) {
    //     getProductDetail(this.$route.query.id).then((res) => {
    //       let pageParams = {
    //         pageNum: 1,
    //         pageSize: 1,
    //       };
    //       let params = {
    //         name: res.data.name,
    //         displayStatus: 1,
    //         languageCode: this.currentLang == "zh" ? "zh-CN" : "en-US",
    //       };
    //       getProductList(params, pageParams).then((res) => {
    //         console.log(res.rows);
    //         if (res.rows.length) {
    //           console.log(this.currentLang);
    //           this.$router.replace({
    //             path: "/product/productDetail/"+this.currentLang == "zh" ? "en" : "zh",
    //             query: { id: res.rows[0].id },
    //           });
    //         }else{
    //           this.$router.replace({
    //             path: "/product/index/"+this.currentLang == "zh" ? "en" : "zh",
    //           });
    //         }

    //       });
    //     });
    //     return;
    //   }
    //   // else if (currentPath == "/product/productDetail/zh") {
    //   //   console.log(this.$route.query.id);
    //   //   getProductDetail(this.$route.query.id).then((res) => {
    //   //     console.log(res.data.name);
    //   //     let pageParams = {
    //   //       pageNum: 1,
    //   //       pageSize: 1,
    //   //     };
    //   //     let params = {
    //   //       name: res.data.name,
    //   //       displayStatus: 1,
    //   //       languageCode: this.currentLang == "zh" ? "zh-CN" : "en-US",
    //   //     };
    //   //     getProductList(params, pageParams).then((res) => {
    //   //       console.log(res.rows[0].id);
    //   //       this.$router.replace({
    //   //         path: "/product/productDetail/en",
    //   //         query: { id: res.rows[0].id },
    //   //       });
    //   //     });
    //   //   });
    //   //   return;
    //   // }
    //   // var newPath = currentPath.replace(/\/(zh|en)$/, "/" + lang);
    //   // if (newPath === currentPath) {
    //   //   var suffix = currentPath.endsWith("/") ? lang : "/" + lang;
    //   //   this.$router.push(currentPath + suffix);
    //   // } else {
    //   //   this.$router.push(newPath);
    //   // }
    // },
    switchLang: function (lang) {
      if (lang === this.currentLang) return;

      const oldLang = this.currentLang; // 保留旧语言
      const currentPath = this.$route.path;
      const currentQuery = { ...this.$route.query };

      // 1. 更新 i18n 语言实例（立即生效）
      if (this.$i18nState) {
        this.$i18nState.locale = lang;
      } else if (this.$i18n) {
        this.$i18n.locale = lang;
      }

      // 辅助函数：替换路径中的语言后缀（/zh 或 /en）
      const replaceLangInPath = (path, newLang) => {
        if (/(\/zh|\/en)$/.test(path)) {
          return path.replace(/\/(zh|en)$/, `/${newLang}`);
        } else {
          // 若路径无后缀则添加（通常不会发生，保底处理）
          return path + (path.endsWith("/") ? newLang : `/${newLang}`);
        }
      };

      // 2. 特殊处理：产品首页（需要更换 query.id）
      if (currentPath.match(/\/product\/index\/(zh|en)$/)) {
        const newPath = replaceLangInPath(currentPath, lang);
        const newId = lang == "zh" ? 12 : 39;
        console.log(newId);
        this.$router.replace({
          path: newPath,
          query: { id: newId },
        });
        return;
      }

      // 3. 特殊处理：产品详情页（根据产品名称查询对应语言的产品ID）
      if (currentPath.match(/\/product\/productDetail\/(zh|en)$/)) {
        const productId = currentQuery.id;
        if (!productId) {
          // 无 ID 则回退到产品首页
          this.$router.replace({
            path: `/product/index/${lang}`,
            query: { id: lang === "zh" ? 12 : 39 },
          });
          return;
        }

        getProductDetail(productId)
          .then((res) => {
            const productName = res.data.name;
            const params = {
              name: productName,
              displayStatus: 1,
              languageCode: lang === "zh" ? "zh-CN" : "en-US",
            };
            return getProductList(params, { pageNum: 1, pageSize: 1 });
          })
          .then((listRes) => {
            if (listRes.rows && listRes.rows.length) {
              const newProductId = listRes.rows[0].id;
              const newPath = replaceLangInPath(currentPath, lang);
              this.$router.replace({
                path: newPath,
                query: { id: newProductId },
              });
            } else {
              // 查不到对应语言产品，回退到产品首页
              this.$router.replace({
                path: `/product/index/${lang}`,
                query: { id: lang === "zh" ? 12 : 39 },
              });
            }
          })
          .catch((error) => {
            console.error("切换语言时产品详情处理失败：", error);
            this.$router.replace({
              path: `/product/index/${lang}`,
              query: { id: lang === "zh" ? 12 : 39 },
            });
          });
        return;
      }

      // 4. 其他所有页面：直接替换语言后缀，保留 query 和 hash
      const newPath = replaceLangInPath(currentPath, lang);
      this.$router.replace({
        path: newPath,
        query: currentQuery,
      });
    },
    // ----- 路由跳转辅助（自动添加语言后缀）-----
    getLocalizedPath: function (rawPath) {
      var lang = this.currentLang;
      if (/\/(zh|en)$/.test(rawPath)) return rawPath;
      var base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
      return base + "/" + lang;
    },

    goPath2: function (path) {
      this.$router.push(this.getLocalizedPath(path));
    },

    goPath: function (item) {
      if (item.path === "/product/index") {
        var lang = this.currentLang;
        this.$router.replace({
          path: this.getLocalizedPath(item.path),
          query: { id: lang === "zh" ? 12 : 39 },
        });
        this.activeCategoryIndex = 0;
        this.currentProduct = this.productCategories[0];
      } else {
        this.$router.push(this.getLocalizedPath(item.path));
        document.documentElement.scrollTop = 0;
      }
    },

    goSubPage: function (child) {
      if (!child.path) return;
      if (child.path.indexOf("?") !== -1) {
        var parts = child.path.split("?");
        var basePath = parts[0];
        var queryString = parts[1];
        var query = {};
        queryString.split("&").forEach(function (pair) {
          var kv = pair.split("=");
          if (kv[0]) query[kv[0]] = decodeURIComponent(kv[1] || "");
        });
        this.$router.push({
          path: this.getLocalizedPath(basePath),
          query: query,
        });
      } else {
        var fullPath = this.getLocalizedPath(child.path);
        if (child.path === "/product/index" || child.path === "/apply") {
          this.$router.push({ path: fullPath, query: { id: child.id } });
        } else {
          this.$router.push(fullPath);
        }
      }
      document.documentElement.scrollTop = 0;
      this.showSubNav = false;
    },

    // 产品弹窗相关
    selectProductCategory: function (cat, index) {
      this.currentProduct = cat;
      this.activeCategoryIndex = index;
      this.activeTypeIndex = -1;
      var lang = this.currentLang;
      this.$router.replace({
        path: this.getLocalizedPath("/product/index"),
        query: { id: cat.id },
      });
      if (!cat.childrens || !cat.childrens.length) {
        this.dialogVisible = false;
      }
    },

    goProductDetail: function (productId, typeIndex) {
      this.activeTypeIndex = typeIndex;
      this.$router.push({
        path: this.getLocalizedPath("/product/index"),
        query: { id: productId },
      });
      this.dialogVisible = false;
      document.documentElement.scrollTop = 0;
    },

    // 导航 hover 交互
    handleNavHover: function (item, index) {
      this.hoveredIndex = index;
      this.showSubNav = true;
      this.activeSubIndex = -1;

      if (item.isProduct && index === 1) {
        // 产品菜单特殊弹窗
        this.dialogVisible = true;
        if (this.productCategories.length) {
          this.currentProduct = this.productCategories[this.activeCategoryIndex] || {
            childrens: [],
          };
        }
      } else {
        this.dialogVisible = false;
      }
    },

    handleNavClick: function (item, index) {
      this.activeIndex = index;
      this.goPath(item);
    },

    // 根据当前路由高亮对应的导航
    updateActiveNavByRoute: function () {
      var currentPath = this.$route.path.replace(/\/(zh|en)$/, "");
      var idx = -1;
      for (var i = 0; i < this.navList.length; i++) {
        if (this.navList[i].path === currentPath) {
          idx = i;
          break;
        }
      }
      if (idx !== -1) this.activeIndex = idx;
    },
  },
};
</script>

<style scoped lang="scss">
/* 响应式断点合并 */
.main {
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

@media (min-width: 300px) {
  .main {
    width: 300px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 600px) {
  .main {
    width: 600px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 700px) {
  .main {
    width: 700px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 800px) {
  .main {
    width: 800px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 1000px) {
  .main {
    width: 1000px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 1100px) {
  .main {
    width: 1100px;
  }
  nav {
    display: none;
  }
  .rightMenu {
    display: block;
  }
  .rightMenu1 {
    display: block;
  }
}
@media (min-width: 1200px) {
  .main {
    width: 1200px;
  }
  nav {
    display: block;
  }
  .rightMenu {
    display: none;
  }
  .rightMenu1 {
    display: none;
  }
}

.header {
  position: fixed;
  width: 100%;
  background-color: rgba(#13458f, 0.8);
  color: #fff;
  z-index: 2002;
  img {
    height: 60px;
    margin-top: 10px;
  }
}

.nav {
  position: relative;
  cursor: pointer;
  text-align: center;
  padding: 18px 24px;
  h2 {
    font-size: 18px;
    line-height: 44px;
  }
  &.active h2 {
    color: #cf2b5d;
    font-weight: bolder;
  }
  &:hover .subNav {
    display: block;
  }
}
.lang-en .nav {
  padding: 18px 12px;
}

.subNav {
  display: none;
  position: absolute;
  background: #fff;
  color: #1e1e1e;
  width: 160px;
  z-index: 999;
  padding: 0 10px 10px;
  top: 78px;
  left: 50%;
  margin-left: -80px;
  div {
    line-height: 40px;
    margin-top: 10px;
    cursor: pointer;
    &:hover {
      color: #cf2b5d;
    }
    &.active span {
      display: block;
      width: 24px;
      height: 3px;
      background-color: #cf2b5d;
      margin: 0 auto;
    }
    span {
      display: none;
      height: 3px;
    }
  }
}
.bounce-enter-active,
.bounce-leave-active {
  transition: opacity 0.2s;
}
.bounce-enter,
.bounce-leave-to {
  opacity: 0;
}
.rightMenu1 {
  width: 80px;
  height: 44px;
  position: absolute;
  right: 50px;
  top: 10px;
}
.rightMenu {
  width: 22px;
  height: 44px;
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;
  span {
    display: block;
    width: 22px;
    height: 2px;
    background-color: rgba(255, 255, 255, 0.8);
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    &::before,
    &::after {
      content: "";
      display: block;
      width: 22px;
      height: 2px;
      background-color: rgba(255, 255, 255, 0.8);
      position: absolute;
      transition: all 0.3s;
    }
    &::before {
      bottom: 8px;
    }
    &::after {
      top: 8px;
    }
  }
}

.menu {
  background-color: #fff;
  > div {
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
}

/* 产品弹窗样式 */
.isProduct {
  position: absolute;
  right: 10px;
  color: #1e1e1e;
  text-align: left;
  li {
    line-height: 40px;
    font-size: 14px;
    padding: 4px 20px;
    cursor: pointer;
    span {
      float: right;
      color: #231815;
      line-height: 40px;
    }
    &:hover,
    &.bg {
      background-color: #0b3576;
      color: #fff;
      span {
        color: #fff;
      }
    }
  }
  .typeName {
    color: #555;
    font-size: 14px;
    text-indent: 14px;
    cursor: pointer;
  }
  .typeLastName {
    background-color: #ededed;
    height: 45px;
    line-height: 45px;
    text-indent: 10px;
    margin-bottom: 10px;
    font-size: 13px;
    cursor: pointer;
    &.active {
      color: #fff;
      background-color: #0b3576;
    }
  }
  .threeType {
    float: left;
    width: 50%;
    padding: 4px;
    box-sizing: border-box;
    > div p {
      line-height: 40px;
      color: #1e1e1e;
      border-bottom: 1px solid #e2e2e2;
      font-size: 14px;
      text-indent: 10px;
      cursor: pointer;
      span {
        float: right;
        margin-right: 6px;
        line-height: 40px;
      }
    }
  }
}
.shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.onlyBar {
  width: 850px;
}
.isProduct {
  // ... 原有样式保持不变

  // 英文环境下的样式覆盖
  &.lang-en {
    width: 640px; // 适当加宽
    // right: 0;                // 调整右偏移（可选）
    // 如果使用 onlyBar 时需要调整位置
    &.onlyBar {
      // right: 760px;          // 对应加宽后的偏移量
    }
  }
}
.el-dropdown-link {
  color: #fff;
  line-height: 42px;
}
.el-dropdown-menu {
  z-index: 3000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue